import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import FilterEditModal from './filter_edit_modal';
import PluginFilterType from '../types/plugin_filter_type';

export default class FilterRow extends React.Component {
  static propTypes = {
    filterFieldOptions: PropTypes.object.isRequired,
    filterModel: PluginFilterType,
    propertyTypes: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired
  };

  state = {
    showEditModal: !!this.props.filterModel.isNew
  }

  currentFieldOption() {
    return this.props.filterFieldOptions[this.props.filterModel.filterField];
  }

  sampleText() {
    return this.currentFieldOption().sample;
  }

  destroyRow = () => {
    this.props.onUpdate(this.props.filterModel.id, "_destroy", true);
  }

  showEditModal = () => {
    this.setState({ showEditModal: true });
  }

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  }

  onUpdate = (key, newVal) => {
    this.props.onUpdate(this.props.filterModel.id, key, newVal);
  }

  filterLabel = () => {
    return this.currentFieldOption().label;
  }

  render() {
    return (
      <React.Fragment>
        <FilterEditModal
          fieldConfig={this.currentFieldOption()}
          filterFieldOptions={this.props.filterFieldOptions}
          filterModel={this.props.filterModel}
          propertyTypes={this.props.propertyTypes}
          show={this.state.showEditModal}
          onClose={this.hideEditModal}
          onUpdate={this.onUpdate}
        />
        <Row className="row-eq-height">
          <Col xs={3} >
            <h5>{this.filterLabel()}</h5>
          </Col>
          <Col xs={5}>
            <span className="text-muted">PREVIEW: </span>
            <span>{this.sampleText()}</span>
          </Col>
          <Col className="text-right" xs={5}>
            <span
              className="right-buffer-lg text-primary clickable"
              name="show-edit-modal"
              onClick={this.showEditModal}
            >
              <FontAwesomeIcon fixedWidth icon={faPencilAlt}/> Edit
            </span>
            <span className="text-danger clickable" name="delete-row" onClick={this.destroyRow}>
              <FontAwesomeIcon fixedWidth icon={faTrashAlt}/> Delete
            </span>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
